import {Injectable, inject} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {DirectusService} from '@frontend/directus';

@Injectable({
  providedIn: 'root',
})
export class SubcriteriaDataService {
  private readonly directusService = inject(DirectusService);

  async loadAllDirectusData() {
    const [directusAttributes, directusSubcriteria, fulfillmentTypes, directusEvaluationCriteria] =
      await Promise.all([
        this.directusService.loadSubCriteriaAttributes(),
        firstValueFrom(this.directusService.loadSubCriteria()),
        this.directusService.loadAttributeFulfillmentTypes(),
        firstValueFrom(this.directusService.loadEvaluationCriteria()),
      ]);

    return {
      directusAttributes,
      directusSubcriteria,
      fulfillmentTypes,
      directusEvaluationCriteria,
    };
  }
}
